// Sukha — página de links (link na bio)

// Destino dos leads do catálogo (webhook do Make).
// Campos enviados, em JSON: email · catalogo · origem.
const CATALOG_ENDPOINT = 'https://hook.us1.make.com/9h2i4b2uer15eax0kptrjbhk7qc28nhn';

const form = document.getElementById('catalog-form');
const modal = document.getElementById('catalog-modal');

if (form) {
  const email = document.getElementById('catalog-email');
  const msg = document.getElementById('catalog-msg');
  const btn = form.querySelector('.catalog-btn');

  const say = (text, state) => {
    msg.textContent = text;
    msg.className = 'catalog-msg' + (state ? ' is-' + state : '');
  };

  const abrirModal = (destinatario) => {
    const alvo = modal && modal.querySelector('#modal-email');
    if (alvo) alvo.textContent = destinatario;
    if (modal && typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      // <dialog> sem suporte: não deixa o usuário sem confirmação.
      say('Pronto! Enviamos o catálogo para ' + destinatario + '.', 'ok');
    }
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (!email.checkValidity()) {
      say('Digite um e-mail válido.', 'error');
      email.focus();
      return;
    }

    // Sem destino não existe sucesso. Antes o formulário dizia "enviamos"
    // com o endpoint vazio e o lead se perdia em silêncio.
    if (!CATALOG_ENDPOINT) {
      say('Cadastro indisponível no momento. Tente mais tarde.', 'error');
      return;
    }

    const destinatario = email.value.trim();

    btn.disabled = true;
    say('Enviando…');

    try {
      const res = await fetch(CATALOG_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: destinatario,
          catalogo: 'maquinas',
          origem: 'instagram-bio',
        }),
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      form.reset();
      say('');
      abrirModal(destinatario);
    } catch (err) {
      say('Não foi possível enviar agora. Tente de novo.', 'error');
    } finally {
      btn.disabled = false;
    }
  });
}

// Fechar o modal: botão e clique no fundo. ESC já é nativo do <dialog>.
if (modal) {
  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.close();
  });
  const fechar = modal.querySelector('[data-fechar]');
  if (fechar) fechar.addEventListener('click', () => modal.close());
}
